const clients = {
  en: {
    common: {
      errorInvalidEmail: 'Enter a valid email address.',
    },
    hub: {
      title: 'Clients',
      subtitle: 'Companies and schools with seats and course licenses on Darsly',
      newClient: 'Add client',
      statTotal: 'Total clients',
      statActive: 'Active',
      statProspects: 'Prospects',
      statMembers: 'Total members',
      searchPlaceholder: 'Search by name...',
      statusFilterAriaLabel: 'Filter by status',
      statusProspect: 'Prospect',
      statusActive: 'Active',
      statusChurned: 'Churned',
      statusSuspended: 'Suspended',
      tableName: 'Client',
      tableStatus: 'Status',
      tableMembers: 'Members',
      tableCreated: 'Added',
      sortLabel: 'Sort',
      sortNewest: 'Newest first',
      sortOldest: 'Oldest first',
      sortNameAsc: 'Name (A-Z)',
      sortNameDesc: 'Name (Z-A)',
      sortMembersDesc: 'Most members',
      sortMembersAsc: 'Fewest members',
      loading: 'Loading clients...',
      emptyTitle: 'No clients yet',
      emptyDescription: 'Create your first client organization to start inviting members and enrolling them in courses.',
      noResultsTitle: 'No matching clients',
      noResultsDescription: 'Try another name or clear the filters.',
      clearFilters: 'Clear filters',
      errorFailedToLoad: 'Could not load clients',
    },
    modal: {
      title: 'New client',
      nameLabel: 'Client name',
      namePlaceholder: 'e.g. Tashkent IT School',
      legalNameLabel: 'Legal name',
      innLabel: 'INN / Tax ID',
      industryLabel: 'Industry',
      sizeBandLabel: 'Company size',
      sizeBandPlaceholder: 'e.g. 11-50',
      billingEmailLabel: 'Billing email',
      phoneLabel: 'Phone',
      websiteLabel: 'Website',
      statusLabel: 'Status',
      notesLabel: 'Notes',
      ownerLabel: 'Responsible staff',
      ownerPlaceholder: 'Select a staff member...',
      ownerNone: 'Nobody',
      submit: 'Create client',
      submitting: 'Creating...',
      errorNameRequired: 'Client name must be at least 2 characters.',
      successCreated: 'Client created',
      editTitle: 'Edit client',
      save: 'Save',
      saving: 'Saving...',
      successUpdated: 'Client updated',
      errorFailedToUpdate: 'Could not update the client',
      errorFailedToCreate: 'Could not create the client',
    },
    detail: {
      back: 'Back to clients',
      loading: 'Loading client...',
      notFound: 'Client not found',
      errorFailedToLoad: 'Could not load this client',
      tabOverview: 'Overview',
      tabPeople: 'People',
      tabEnrollments: 'Enrollments',
      editCta: 'Edit',
      menuLabel: 'Client actions',
      deleteCta: 'Delete client',
      deleteConfirmTitle: 'Delete {name}?',
      deleteConfirmMessage: 'The client disappears from the list, with its members, cohorts and seat packs. Learners keep their accounts and course access.',
      successDeleted: 'Client deleted',
      errorFailedToDelete: 'Could not delete the client',
    },
    overview: {
      loading: 'Loading overview...',
      errorFailedToLoad: 'Could not load the overview',
      memberCount: 'Members',
      enrolledMemberCount: 'Joined members',
      invitedMemberCount: 'Invited members',
      activeEnrollments: 'Active enrollments',
      completedEnrollments: 'Completed enrollments',
      avgProgress: 'Avg. progress',
      courseBreakdownTitle: 'Course breakdown',
      courseBreakdownEmpty: 'No course enrollments yet',
      tableCourse: 'Course',
      tableEnrolled: 'Enrolled',
      tableCompleted: 'Completed',
      tableProgress: 'Completion',
    },
    about: {
      title: 'About the client',
      createdAt: 'Added on',
      owner: 'Responsible staff',
      empty: 'No details added yet.',
      addDetails: 'Add details',
    },
    people: {
      inviteFormTitle: 'Invite a member',
      inviteHint: 'An email or a phone number is required.',
      namePlaceholder: 'Name (optional)',
      emailPlaceholder: 'email@company.com',
      phonePlaceholder: '+998 90 123 45 67',
      inviteCta: 'Invite',
      inviting: 'Inviting...',
      errorProvideContact: 'Enter an email or a phone number.',
      successInvited: 'Invite added',
      successAdded: 'Member added',
      errorFailedToInvite: 'Could not add the member. Check the email or phone number: they may already be in this client.',
      successRemoved: 'Member removed',
      errorFailedToRemove: 'Could not remove the member',
      removeConfirmTitle: 'Remove {name} from this client?',
      removeConfirmMessage: 'They leave this client. Their Darsly account and any course access stay as they are.',
      removeConfirm: 'Remove',
      emptyTitle: 'No members yet',
      emptyDescription: 'Invite people by email or phone — they will be enrolled automatically once they sign up.',
      searchPlaceholder: 'Search members...',
      noMatchTitle: 'No matching members',
      noMatchDescription: 'Try another name or contact, or clear the filter.',
      tableMember: 'Member',
      tableRole: 'Role',
      tableStatus: 'Status',
      roleLearner: 'Learner',
      roleOrgAdmin: 'Org admin',
      statusInvited: 'Invited',
      statusEnrolled: 'Joined',
    },
    enrollments: {
      selectCourseLabel: 'Course',
      selectCoursePlaceholder: 'Select a course...',
      selectMembersLabel: 'Members to enroll',
      selectAll: 'Select all',
      clearAll: 'Clear',
      selectedCount: '{count} selected',
      noEligibleMembers: 'No enrolled members with a linked account yet. Invite members in the People tab first.',
      enrollCta: 'Enroll selected',
      enrolling: 'Enrolling...',
      confirmTitle: 'Enroll {count} members in {course}?',
      confirmMessage: 'They get access to the course right away and are notified. No payment is created.',
      confirmCta: 'Enroll',
      errorSelectCourse: 'Select a course first.',
      errorSelectMembers: 'Select at least one member.',
      errorFailed: 'Could not enroll the members',
      successSummary: '{enrolled} enrolled, {attached} attached, {failed} failed',
      resultsTitle: 'Results',
      retryFailed: 'Select the failed ones again',
      summaryLine: '{total} processed · {enrolled} enrolled · {attached} attached · {skipped} already enrolled · {failed} failed',
      resultEnrolled: 'Enrolled',
      resultAttached: 'Attached',
      resultAlready: 'Already enrolled',
      resultError: 'Error',
    },
  },
  ru: {
    common: {
      errorInvalidEmail: 'Введите корректный адрес email.',
    },
    hub: {
      title: 'Клиенты',
      subtitle: 'Компании и школы с местами и лицензиями на курсы Darsly',
      newClient: 'Добавить клиента',
      statTotal: 'Всего клиентов',
      statActive: 'Активные',
      statProspects: 'Потенциальные',
      statMembers: 'Всего участников',
      searchPlaceholder: 'Поиск по названию...',
      statusFilterAriaLabel: 'Фильтр по статусу',
      statusProspect: 'Потенциальный',
      statusActive: 'Активный',
      statusChurned: 'Ушедший',
      statusSuspended: 'Приостановлен',
      tableName: 'Клиент',
      tableStatus: 'Статус',
      tableMembers: 'Участники',
      tableCreated: 'Добавлен',
      sortLabel: 'Сортировка',
      sortNewest: 'Сначала новые',
      sortOldest: 'Сначала старые',
      sortNameAsc: 'Название (А-Я)',
      sortNameDesc: 'Название (Я-А)',
      sortMembersDesc: 'Больше участников',
      sortMembersAsc: 'Меньше участников',
      loading: 'Загрузка клиентов...',
      emptyTitle: 'Пока нет клиентов',
      emptyDescription: 'Создайте первую клиентскую организацию, чтобы приглашать участников и записывать их на курсы.',
      noResultsTitle: 'Подходящих клиентов нет',
      noResultsDescription: 'Попробуйте другое название или сбросьте фильтры.',
      clearFilters: 'Сбросить фильтры',
      errorFailedToLoad: 'Не удалось загрузить клиентов',
    },
    modal: {
      title: 'Новый клиент',
      nameLabel: 'Название клиента',
      namePlaceholder: 'например, IT-школа Ташкента',
      legalNameLabel: 'Юридическое название',
      innLabel: 'ИНН',
      industryLabel: 'Отрасль',
      sizeBandLabel: 'Размер компании',
      sizeBandPlaceholder: 'например, 11-50',
      billingEmailLabel: 'Email для счетов',
      phoneLabel: 'Телефон',
      websiteLabel: 'Веб-сайт',
      statusLabel: 'Статус',
      notesLabel: 'Заметки',
      ownerLabel: 'Ответственный сотрудник',
      ownerPlaceholder: 'Выберите сотрудника...',
      ownerNone: 'Не назначен',
      submit: 'Создать клиента',
      submitting: 'Создание...',
      errorNameRequired: 'Название клиента должно содержать не менее 2 символов.',
      successCreated: 'Клиент создан',
      editTitle: 'Редактирование клиента',
      save: 'Сохранить',
      saving: 'Сохранение...',
      successUpdated: 'Клиент обновлён',
      errorFailedToUpdate: 'Не удалось обновить клиента',
      errorFailedToCreate: 'Не удалось создать клиента',
    },
    detail: {
      back: 'Назад к клиентам',
      loading: 'Загрузка клиента...',
      notFound: 'Клиент не найден',
      errorFailedToLoad: 'Не удалось загрузить клиента',
      tabOverview: 'Обзор',
      tabPeople: 'Участники',
      tabEnrollments: 'Зачисления',
      editCta: 'Изменить',
      menuLabel: 'Действия с клиентом',
      deleteCta: 'Удалить клиента',
      deleteConfirmTitle: 'Удалить клиента «{name}»?',
      deleteConfirmMessage: 'Клиент исчезнет из списка вместе с участниками, когортами и пакетами мест. Аккаунты учащихся и доступ к курсам не изменятся.',
      successDeleted: 'Клиент удалён',
      errorFailedToDelete: 'Не удалось удалить клиента',
    },
    overview: {
      loading: 'Загрузка обзора...',
      errorFailedToLoad: 'Не удалось загрузить обзор',
      memberCount: 'Участники',
      enrolledMemberCount: 'Участники с аккаунтом',
      invitedMemberCount: 'Приглашённые участники',
      activeEnrollments: 'Активные зачисления',
      completedEnrollments: 'Завершённые зачисления',
      avgProgress: 'Средний прогресс',
      courseBreakdownTitle: 'По курсам',
      courseBreakdownEmpty: 'Пока нет зачислений на курсы',
      tableCourse: 'Курс',
      tableEnrolled: 'Зачислено',
      tableCompleted: 'Завершено',
      tableProgress: 'Завершение',
    },
    about: {
      title: 'О клиенте',
      createdAt: 'Добавлен',
      owner: 'Ответственный сотрудник',
      empty: 'Данные пока не заполнены.',
      addDetails: 'Добавить данные',
    },
    people: {
      inviteFormTitle: 'Пригласить участника',
      inviteHint: 'Нужен email или номер телефона.',
      namePlaceholder: 'Имя (необязательно)',
      emailPlaceholder: 'email@company.com',
      phonePlaceholder: '+998 90 123 45 67',
      inviteCta: 'Пригласить',
      inviting: 'Приглашение...',
      errorProvideContact: 'Введите email или номер телефона.',
      successInvited: 'Приглашение добавлено',
      successAdded: 'Участник добавлен',
      errorFailedToInvite: 'Не удалось добавить участника. Проверьте email или телефон: возможно, он уже есть у этого клиента.',
      successRemoved: 'Участник убран',
      errorFailedToRemove: 'Не удалось убрать участника',
      removeConfirmTitle: 'Убрать «{name}» из этого клиента?',
      removeConfirmMessage: 'Он покинет этого клиента. Его аккаунт Darsly и доступ к курсам не изменятся.',
      removeConfirm: 'Убрать',
      emptyTitle: 'Пока нет участников',
      emptyDescription: 'Пригласите людей по email или телефону — они будут автоматически зачислены после регистрации.',
      searchPlaceholder: 'Поиск участников...',
      noMatchTitle: 'Участники не найдены',
      noMatchDescription: 'Попробуйте другое имя или контакт либо сбросьте фильтр.',
      tableMember: 'Участник',
      tableRole: 'Роль',
      tableStatus: 'Статус',
      roleLearner: 'Учащийся',
      roleOrgAdmin: 'Админ организации',
      statusInvited: 'Приглашён',
      statusEnrolled: 'В организации',
    },
    enrollments: {
      selectCourseLabel: 'Курс',
      selectCoursePlaceholder: 'Выберите курс...',
      selectMembersLabel: 'Участники для зачисления',
      selectAll: 'Выбрать все',
      clearAll: 'Очистить',
      selectedCount: 'Выбрано: {count}',
      noEligibleMembers: 'Пока нет зачисленных участников с привязанным аккаунтом. Сначала пригласите участников на вкладке «Участники».',
      enrollCta: 'Зачислить выбранных',
      enrolling: 'Зачисление...',
      confirmTitle: 'Зачислить участников ({count}) на курс «{course}»?',
      confirmMessage: 'Доступ к курсу откроется сразу, участники получат уведомление. Платёж не создаётся.',
      confirmCta: 'Зачислить',
      errorSelectCourse: 'Сначала выберите курс.',
      errorSelectMembers: 'Выберите хотя бы одного участника.',
      errorFailed: 'Не удалось зачислить участников',
      successSummary: 'Зачислено: {enrolled}, привязано: {attached}, ошибок: {failed}',
      resultsTitle: 'Результаты',
      retryFailed: 'Выбрать неудавшихся снова',
      summaryLine: 'Обработано: {total} · зачислено: {enrolled} · привязано: {attached} · уже зачислены: {skipped} · ошибок: {failed}',
      resultEnrolled: 'Зачислен',
      resultAttached: 'Привязан',
      resultAlready: 'Уже зачислен',
      resultError: 'Ошибка',
    },
  },
  uz: {
    common: {
      errorInvalidEmail: "To'g'ri email manzilini kiriting.",
    },
    hub: {
      title: 'Mijozlar',
      subtitle: "Darsly'da o'rin va kurs litsenziyalariga ega kompaniyalar va maktablar",
      newClient: "Mijoz qo'shish",
      statTotal: 'Jami mijozlar',
      statActive: 'Faol',
      statProspects: 'Potensial',
      statMembers: "Jami a'zolar",
      searchPlaceholder: 'Nomi bo\'yicha qidirish...',
      statusFilterAriaLabel: "Holat bo'yicha filtr",
      statusProspect: 'Potensial',
      statusActive: 'Faol',
      statusChurned: 'Ketgan',
      statusSuspended: "To'xtatilgan",
      tableName: 'Mijoz',
      tableStatus: 'Holat',
      tableMembers: "A'zolar",
      tableCreated: "Qo'shilgan",
      sortLabel: 'Saralash',
      sortNewest: 'Avval yangilari',
      sortOldest: 'Avval eskilari',
      sortNameAsc: 'Nomi (A-Z)',
      sortNameDesc: 'Nomi (Z-A)',
      sortMembersDesc: "A'zolar: ko'pdan kamga",
      sortMembersAsc: "A'zolar: kamdan ko'pga",
      loading: 'Mijozlar yuklanmoqda...',
      emptyTitle: "Hali mijozlar yo'q",
      emptyDescription: "A'zolarni taklif qilish va ularni kurslarga yozish uchun birinchi mijoz tashkilotini yarating.",
      noResultsTitle: 'Mos mijoz topilmadi',
      noResultsDescription: "Boshqa nom bilan qidiring yoki filtrlarni tozalang.",
      clearFilters: 'Filtrlarni tozalash',
      errorFailedToLoad: "Mijozlarni yuklab bo'lmadi",
    },
    modal: {
      title: 'Yangi mijoz',
      nameLabel: 'Mijoz nomi',
      namePlaceholder: 'masalan, Toshkent IT maktabi',
      legalNameLabel: 'Yuridik nomi',
      innLabel: 'STIR',
      industryLabel: 'Soha',
      sizeBandLabel: 'Kompaniya hajmi',
      sizeBandPlaceholder: 'masalan, 11-50',
      billingEmailLabel: 'Hisob-faktura email',
      phoneLabel: 'Telefon',
      websiteLabel: 'Veb-sayt',
      statusLabel: 'Holat',
      notesLabel: 'Izohlar',
      ownerLabel: "Mas'ul xodim",
      ownerPlaceholder: 'Xodimni tanlang...',
      ownerNone: 'Tayinlanmagan',
      submit: 'Mijoz yaratish',
      submitting: 'Yaratilmoqda...',
      errorNameRequired: 'Mijoz nomi kamida 2 ta belgidan iborat bo\'lishi kerak.',
      successCreated: 'Mijoz yaratildi',
      editTitle: 'Mijozni tahrirlash',
      save: 'Saqlash',
      saving: 'Saqlanmoqda...',
      successUpdated: 'Mijoz yangilandi',
      errorFailedToUpdate: "Mijozni yangilab bo'lmadi",
      errorFailedToCreate: 'Mijoz yaratib bo\'lmadi',
    },
    detail: {
      back: 'Mijozlarga qaytish',
      loading: 'Mijoz yuklanmoqda...',
      notFound: 'Mijoz topilmadi',
      errorFailedToLoad: 'Mijozni yuklab bo\'lmadi',
      tabOverview: 'Umumiy',
      tabPeople: "A'zolar",
      tabEnrollments: 'Yozilishlar',
      editCta: 'Tahrirlash',
      menuLabel: 'Mijoz amallari',
      deleteCta: "Mijozni o'chirish",
      deleteConfirmTitle: "{name} o'chirilsinmi?",
      deleteConfirmMessage: "Mijoz ro'yxatdan a'zolari, kogortalari va o'rin paketlari bilan birga yo'qoladi. O'quvchilarning hisoblari va kurslarga kirishi o'zgarmaydi.",
      successDeleted: "Mijoz o'chirildi",
      errorFailedToDelete: "Mijozni o'chirib bo'lmadi",
    },
    overview: {
      loading: 'Umumiy ma\'lumot yuklanmoqda...',
      errorFailedToLoad: 'Umumiy ma\'lumotni yuklab bo\'lmadi',
      memberCount: "A'zolar",
      enrolledMemberCount: "Qo'shilgan a'zolar",
      invitedMemberCount: "Taklif qilingan a'zolar",
      activeEnrollments: 'Faol yozilishlar',
      completedEnrollments: 'Yakunlangan yozilishlar',
      avgProgress: "O'rtacha progress",
      courseBreakdownTitle: "Kurslar bo'yicha",
      courseBreakdownEmpty: "Hali kursga yozilishlar yo'q",
      tableCourse: 'Kurs',
      tableEnrolled: 'Yozilgan',
      tableCompleted: 'Yakunlangan',
      tableProgress: 'Yakunlanish',
    },
    about: {
      title: 'Mijoz haqida',
      createdAt: "Qo'shilgan sana",
      owner: "Mas'ul xodim",
      empty: "Hali ma'lumot kiritilmagan.",
      addDetails: "Ma'lumot qo'shish",
    },
    people: {
      inviteFormTitle: "A'zoni taklif qilish",
      inviteHint: 'Email yoki telefon raqami kerak.',
      namePlaceholder: 'Ism (ixtiyoriy)',
      emailPlaceholder: 'email@company.com',
      phonePlaceholder: '+998 90 123 45 67',
      inviteCta: 'Taklif qilish',
      inviting: 'Taklif qilinmoqda...',
      errorProvideContact: 'Email yoki telefon raqamini kiriting.',
      successInvited: "Taklif qo'shildi",
      successAdded: "A'zo qo'shildi",
      errorFailedToInvite: "A'zoni qo'shib bo'lmadi. Email yoki telefonni tekshiring: ular bu mijozda allaqachon bo'lishi mumkin.",
      successRemoved: "A'zo mijozdan chiqarildi",
      errorFailedToRemove: "A'zoni mijozdan chiqarib bo'lmadi",
      removeConfirmTitle: '{name} mijozdan chiqarilsinmi?',
      removeConfirmMessage: "U ushbu mijozdan chiqadi. Uning Darsly hisobi va kurslarga kirishi o'zgarmaydi.",
      removeConfirm: 'Chiqarish',
      emptyTitle: "Hali a'zolar yo'q",
      emptyDescription: "Odamlarni email yoki telefon orqali taklif qiling — ular ro'yxatdan o'tgach avtomatik yoziladi.",
      searchPlaceholder: "A'zolarni qidirish...",
      noMatchTitle: "Mos a'zo topilmadi",
      noMatchDescription: 'Boshqa ism yoki aloqa bilan qidiring yoki filtrni tozalang.',
      tableMember: "A'zo",
      tableRole: 'Rol',
      tableStatus: 'Holat',
      roleLearner: "O'quvchi",
      roleOrgAdmin: 'Tashkilot admini',
      statusInvited: 'Taklif qilingan',
      statusEnrolled: "Qo'shilgan",
    },
    enrollments: {
      selectCourseLabel: 'Kurs',
      selectCoursePlaceholder: 'Kursni tanlang...',
      selectMembersLabel: "Yoziladigan a'zolar",
      selectAll: 'Barchasini tanlash',
      clearAll: 'Tozalash',
      selectedCount: '{count} ta tanlandi',
      noEligibleMembers: "Hali bog'langan hisobga ega yozilgan a'zolar yo'q. Avval «A'zolar» bo'limida a'zolarni taklif qiling.",
      enrollCta: 'Tanlanganlarni yozish',
      enrolling: 'Yozilmoqda...',
      confirmTitle: "{count} ta a'zo «{course}» kursiga yozilsinmi?",
      confirmMessage: "Ularga kursga kirish darhol ochiladi va bildirishnoma yuboriladi. To'lov yaratilmaydi.",
      confirmCta: 'Yozish',
      errorSelectCourse: 'Avval kursni tanlang.',
      errorSelectMembers: "Kamida bitta a'zoni tanlang.",
      errorFailed: "A'zolarni yozib bo'lmadi",
      successSummary: '{enrolled} yozildi, {attached} bog\'landi, {failed} xato',
      resultsTitle: 'Natijalar',
      retryFailed: 'Xato chiqqanlarni qayta tanlash',
      summaryLine: 'Jami: {total} · yozildi: {enrolled} · bog\'landi: {attached} · allaqachon yozilgan: {skipped} · xato: {failed}',
      resultEnrolled: 'Yozildi',
      resultAttached: "Bog'landi",
      resultAlready: 'Allaqachon yozilgan',
      resultError: 'Xato',
    },
  },
};

export default clients;
